
import defaultsDeep from 'lodash/defaultsDeep';


// Default Model Blueprint
export class Model {
  constructor(attributes = {}) {
    defaultsDeep(this, attributes, this.defaults);
  }
}

